let contactIndexFunctions = (function () {
  const modules = {};

  modules.submitConfirmContact = function (button) {
    let form = $("#form-contact");
    let data = new FormData(form[0]);
    let submitAjax = $.ajax({
      url: form.prop("action"),
      method: form.prop("method"),
      data: data,
      processData: false,
      contentType: false
    })
    submitAjax.done(function (response) {
      if (response.status) {
        window.location.href = Routes.contact_thanks_path();
      }
      grecaptcha.reset();
    })
    submitAjax.fail(function (response) {
      const messageList = response.responseJSON.errors;
      commonFunctions.showMessageValidate(messageList);
      commonFunctions.enableButtonWhenLoadingDone(button);
      if (messageList.family_name || messageList.last_name) {
        let mess = messageList.family_name === "" ? messageList.last_name : messageList.family_name
        $('p.error-message[data-field=user_name]').append(mess).show();
      }
      $('html, body').animate({
        scrollTop: $($('.validate-error')[0]).offset().top - 150
      }, 0);
      grecaptcha.reset();
    })
  }

  return modules;
}(window.jQuery, window, document));

$(document).ready(function () {
  $(document).on("click", "#js-btn-submit-contact", function (event) {
    event.preventDefault();
    grecaptcha.execute();
  })

  $('#contact_purpose').change(function() {
    var selectValue = $(this).val();
    var errorMessage = $(this).closest('.validate ').find('.error-message');
    if (selectValue === '') {
        errorMessage.show();
        $(this).addClass('validate-error')

    } else {
      errorMessage.hide();
      $(this).removeClass('validate-error')
    }
  });

  $('#contact_family_name').keyup(function() {
    var familyName = $(this).val();

    var errorMessage = $(this).closest('.validate ').find('.error-message');
    if (familyName === '') {
      errorMessage.show();
      $(this).addClass('validate-error')
      errorMessage.text('お名前が入力されていません。')
    } else {
      $(this).removeClass('validate-error')
      if (!$("#contact_last_name").hasClass('validate-error')) {
        errorMessage.hide();
      }
    }
  });

  $('#contact_last_name').keyup(function() {
    var lastName = $(this).val();

    var errorMessage = $(this).closest('.validate ').find('.error-message');
    if (lastName === '') {
        errorMessage.show();
        $(this).addClass('validate-error')
        errorMessage.text('お名前が入力されていません。')
    } else {
      $(this).removeClass('validate-error')
      if (!$("#contact_family_name").hasClass('validate-error')) {
        errorMessage.hide();
      }
    }
  });

  $('#contact_email').keyup(function() {
    var emailValue = $(this).val();
    var errorMessage = $(this).closest('.validate ').find('.error-message');
    if (emailValue === '') {
        errorMessage.show();
        $(this).addClass('validate-error')
        errorMessage.text('メールアドレスが入力されていません。')

    } else {
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailValue)) {
        errorMessage.show();
        errorMessage.text('正しくメールアドレスを入力してください。')
        if (!$(this).hasClass('validate-error')) {
          $(this).addClass('validate-error')
        }
      } else {
        errorMessage.hide();
        $(this).removeClass('validate-error')
      }
    }
  });

  $('#contact_email_confirmation').keyup(function() {
    const originalEmail = $('#contact_email').val();
    var emailValue = $(this).val();
    var errorMessage = $(this).closest('.validate ').find('.error-message');
    if (originalEmail !== emailValue) {
        errorMessage.show();
        $(this).addClass('validate-error')
        errorMessage.text('「メールアドレス」と「メールアドレス(確認用)」は同じく入力してください。')

    } else {
      errorMessage.hide();
      $(this).removeClass('validate-error')
    }
  });

  $('#contact_telephone').keyup(function() {
    var phoneValue = $(this).val();
    var errorMessage = $(this).closest('.validate ').find('.error-message');
    if (phoneValue === '') {
        errorMessage.show();
        $(this).addClass('validate-error')
        errorMessage.text('直通電話番号が入力されていません。')

    } else {
      var phoneRegex = /^\d{10,11}$/;
      if (!phoneRegex.test(phoneValue)) {
        errorMessage.show();
        errorMessage.text('正しく直通電話番号を入力してください。')
        if (!$(this).hasClass('validate-error')) {
          $(this).addClass('validate-error')
        }
      } else {
        errorMessage.hide();
        $(this).removeClass('validate-error')
      }
    }
  });

  $('#contact_content').keyup(function() {
    var content = $(this).val();

    var errorMessage = $(this).closest('.validate ').find('.error-message');
    if (content === '') {
      errorMessage.show();
      $(this).addClass('validate-error')
      errorMessage.text('お問い合わせ内容が入力されていません。')
    } else {
      $(this).removeClass('validate-error')
      errorMessage.hide();
      $(this).removeClass('validate-error')
    }
  });
});

window.verifyRecaptcha = function () {
  let button = $("#js-btn-submit-contact")
  commonFunctions.disabledButtonWhenLoading(button)
  contactIndexFunctions.submitConfirmContact(button);
}
